import {message} from 'antd';

export default {
    info: (msg: string) => {
        message.info(msg);
    },

    error: (msg: string) => {
        message.error(msg);
    },

    warn: (msg: string) => {
        message.warn(msg);
    },
};
